<template>
  <div>
    <form class="form" ref="update_password_request">
      <!--begin::Card-->
      <div class="card card-custom">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title">
            <h3 class="card-label font-weight-bolder text-dark">
              تغییر/افزودن گذرواژه
            </h3>
          </div>
          <div class="card-toolbar">
            <button
              type="button"
              class="btn btn-sm btn-primary mr-2"
              @click="request()"
              ref="update_password_request_btn"
            >
              تایید
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="card-body">
          <div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-alert">
                گذرواژه
              </label>
              <div class="col-lg-9 col-xl-6">
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i
                        class="fa"
                        @click="showPassword = !showPassword"
                        :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']"
                      ></i
                    ></span>
                  </div>
                  <input
                    class="form-control form-control-lg form-control-solid"
                    :type="[showPassword ? 'text' : 'password']"
                    name="password"
                    ref="password"
                    dir="ltr"
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-xl-3 col-lg-3 col-form-label text-alert">
                تکرار گذرواژه
              </label>
              <div class="col-lg-9 col-xl-6">
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i
                        class="fa"
                        @click="showConfirmPassword = !showConfirmPassword"
                        :class="[
                          showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'
                        ]"
                      ></i
                    ></span>
                  </div>
                  <input
                    class="form-control form-control-lg form-control-solid"
                    :type="[showConfirmPassword ? 'text' : 'password']"
                    name="password_confirmation"
                    ref="password_confirmation"
                    dir="ltr"
                    autocomplete="off"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";
import { UPDATE_PASSWORD_USER_ADMIN } from "@/core/services/store/admin/users.module.js";
import { UPDATE_PASSWORD_USER_COMPANY } from "@/core/services/store/company/users.module.js";

export default {
  name: "ChangePasswordUser",
  props: ["value", "userId"],
  data() {
    return {
      off: "off",
      time: 0,
      timer: null,
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      showPassword: false,
      showConfirmPassword: false
    };
  },
  mounted() {
    const update_password_request = this.$refs["update_password_request"];

    this.fv = formValidation(update_password_request, {
      fields: {
        password: {
          validators: {
            notEmpty: {
              message: "گذرواژه صحیح نیست."
            }
          }
        },
        password_confirmation: {
          validators: {
            notEmpty: {
              message: "تکرار گذرواژه صحیح نیست."
            },
            identical: {
              compare: () => {
                return this.$refs["password"].value;
              },
              message: "تکرار گذرواژه یکسان نیست."
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  methods: {
    request() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          const submitButton = this.$refs["update_password_request_btn"];
          this.disableBtn(submitButton);
          this.$store
            .dispatch(
              this.isAdmin
                ? UPDATE_PASSWORD_USER_ADMIN
                : UPDATE_PASSWORD_USER_COMPANY,
              [
                this.userId,
                {
                  password: this.$refs["password"].value,
                  password_confirmation: this.$refs["password_confirmation"]
                    .value
                }
              ]
            )
            .then(response => {
              this.time = response["expires_after"];
              this.startTimer();
              this.enableBtn(submitButton);
              this.showMessage("گذرواژه شما با موفقیت تغییر کرد.");
              this.$emit("input", false);
            })
            .catch(() => {
              this.enableBtn(submitButton);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به طور صحیح تکمیل نمایید");
        }
      });
    },

    startTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.time > 0) {
            this.time--;
          } else {
            this.stopTimer();
          }
        }, 1000);
      }
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.time = 0;
    }
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo"])
  }
};
</script>
